import request from '@/utils/request'
// 新增erp数据
export function saveErp (data) {
  return request({
    url: '/erp/saveErp',
    method: 'post',
    data
  })
}

/**
 * 核验accessToken
 * @param data
 * @returns {*}
 */
export function authToken (data) {
  return request({
    url: '/erp/authToken',
    method: 'post',
    data
  })
}

// 开启或关闭同步 type 1:商品同步 2：订单同步 3：售后同步
export function updateAuth (params) {
  return request({
    url: '/erp/updateAuth',
    method: 'get',
    params: params
  })
}

// 新增erp数据
export function erpInfo (params) {
  return request({
    url: '/erp/erpInfo',
    method: 'get',
    params: params
  })
}

// 新增erp数据
export function updateErp (params) {
  return request({
    url: '/erp/updateErp',
    method: 'POST',
    params
  })
}

// 新增erp数据
export function inventoryQuery (params) {
  return request({
    url: '/erp/inventoryQuery',
    method: 'get',
    params: params
  })
}

// 新增erp数据
export function cancelOrder (params) {
  return request({
    url: '/erp/cancelOrder',
    method: 'get',
    params: params
  })
}

// 查询分仓列表
export function partnerQuery (params) {
  return request({
    url: '/erp/partnerQuery',
    method: 'get',
    params: params
  })
}

// 查询供应商列表
export function supplierQuery (params) {
  return request({
    url: '/erp/supplierValue',
    method: 'get',
    params: params
  })
}

// 同步分仓id
export function coidUpdate (params) {
  return request({
    url: '/erp/coidUpdate',
    method: 'get',
    params: params
  })
}

// 商品同步分仓id
export function coidUpdateProduct (params) {
  return request({
    url: '/erp/coidUpdateProduct?pIds='+params.pIds+"&wmsCoId="+params.wmsCoId,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/erp.js